const InputRequired = {
    borderLeft: "3px solid red !important",
};

export class StyleHelper {
    static get InputRequired() {
        return InputRequired;
    }
}